import { cn } from "../../utils/helpers";
import { type TabProps } from "./types";

type TabsContentProps = {
  tabs: React.ReactElement<TabProps>[];
  activeTab: string;
  keepMounted: boolean;
  baseId?: string;
};

export function TabsContent({
  tabs,
  activeTab,
  keepMounted,
  baseId,
}: TabsContentProps) {
  if (keepMounted) {
    return (
      <div className="p-3 sm:p-4">
        {tabs.map(tab => {
          const panelId = baseId
            ? `${baseId}-panel-${tab.props.value}`
            : `${tab.props.value}-panel`;
          const tabId =
            tab.props.id ||
            (baseId ? `${baseId}-tab-${tab.props.value}` : tab.props.value);
          const isSelected = tab.props.value === activeTab;

          return (
            <div
              key={tab.props.value}
              id={panelId}
              role="tabpanel"
              aria-labelledby={tabId}
              tabIndex={0}
              className={cn(
                `tab-${tab.props.value}-content`,
                "transition-[opacity,transform] duration-200 ease-out",
                isSelected
                  ? "translate-x-0 opacity-100"
                  : "absolute invisible translate-x-2 opacity-0",
              )}>
              {tab.props.children}
            </div>
          );
        })}
      </div>
    );
  }

  const selectedTab = tabs.find(tab => tab.props.value === activeTab);
  if (!selectedTab) return null;

  const panelId = baseId
    ? `${baseId}-panel-${selectedTab.props.value}`
    : `${selectedTab.props.value}-panel`;
  const tabId =
    selectedTab.props.id ||
    (baseId
      ? `${baseId}-tab-${selectedTab.props.value}`
      : selectedTab.props.value);

  return (
    <div className="p-3 sm:p-4">
      <div
        id={panelId}
        role="tabpanel"
        aria-labelledby={tabId}
        tabIndex={0}
        className={cn(
          `tab-${selectedTab.props.value}-content`,
          "transition-[opacity,transform] duration-200 ease-out translate-x-0 opacity-100",
        )}>
        {selectedTab.props.children}
      </div>
    </div>
  );
}
